import script from "./SizeSearch.vue?vue&type=script&lang=ts&setup=true"
export * from "./SizeSearch.vue?vue&type=script&lang=ts&setup=true"

import "./SizeSearch.vue?vue&type=style&index=0&id=18e64882&lang=scss"

const __exports__ = script;

export default __exports__